import { navigateTo } from "client_legacy/ndaw/navigator";
import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { IOwaNavigator, generateUrl } from "./common";

export class DefaultOnlineOwaNavigator implements IOwaNavigator {
	public emailOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl("mail"),
			inNewWindow
		);
	}

	public composeEmailInNewWindow(options: { to?: string; body?: string; } = {}): void {
		const {
			to,
			body
		} = options;

		windowFactory.open(
			this.generateUrl(
				"mail/deeplink/compose",
				{
					to,
					body
				}
			),
			"_blank",
			"width=1000,height=600,left=100,top=100"
		);
	}

	public emailItem(options: { id: string; inNewWindow?: boolean; }): void {
		const {
			id,
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl(
				"owa",
				{
					itemID: id,
					exvsurl: "1",
					viewmodel: "ReadMessageItem"
				}
			),
			inNewWindow
		);
	}

	public composeAppointmentInNewWindow(): void {
		windowFactory.open(
			this.generateUrl("calendar/deeplink/compose"),
			"_blank",
			"width=1300,height=700,left=100,top=100"
		);
	}

	public calendarOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl("calendar"),
			inNewWindow
		);
	}

	public appointmentItem(options: { id: string; inNewWindow?: boolean; }): void {
		const {
			id,
			inNewWindow
		} = options;

		navigateTo(
			this.generateUrl(
				`calendar/item/${encodeURIComponent(id)}`
			),
			inNewWindow
		);
	}

	public peopleOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl("people"),
			inNewWindow
		);
	}

	private generateUrl(relativePath: string, queryParameters?: Record<string, string | undefined>): string {
		return generateUrl(
			"https://outlook.office.com",
			relativePath,
			queryParameters
		);
	}
}
